// extracted by mini-css-extract-plugin
export var aiStarIcon = "_jn-2";
export var container = "_jn-4";
export var dismissButton = "_jn-3";
export var hasPaddingBottom = "_jn-6";
export var last = "_jn-e";
export var scrollbarThumb = "_jn-c";
export var scrollbarTrack = "_jn-b";
export var selected = "_jn-9";
export var spin = "_jn-1";
export var spinning = "_jn-0";
export var suggestionItem = "_jn-d";
export var suggestionsPanel = "_jn-5";
export var tonePill = "_jn-8";
export var tonesContainer = "_jn-7";
export var unselected = "_jn-a";